// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcj_a bgu_b bgu_tu bgu_qz bgu_ra bgu_uo","PanelFooter--link":"bcj_b"};